import { IRiskIndicatory } from 'APIPackage/DictionariesModule/interfaces/IRiskIndicatory';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryRiskIndicatorySelectOption = makeCreateDictionarySelectOption<IRiskIndicatory>(
  'id',
  'description',
);
